var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAirportShuttle = function SvgAirportShuttle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15c.889 0 1.687.386 2.236 1h1.754l.007-3H17a2 2 0 01-2-2H2v5h1.764c.55-.614 1.348-1 2.236-1 .888 0 1.687.386 2.236 1h7.528c.55-.614 1.348-1 2.236-1zm-9 3a3 3 0 11-6 0H2a2 2 0 01-2-2V5a2 2 0 012-2h18.083a2 2 0 011.921 1.445L24 11.36l-.01 4.644a2 2 0 01-2 1.996H21a3 3 0 11-6 0H9zm8-7h4.814l-1.731-6H17v6zm-2-6h-3v4h3V5zM7 5v4h3V5H7zM5 5H2v4h3V5zm1 14a1 1 0 100-2 1 1 0 000 2zm12 0a1 1 0 100-2 1 1 0 000 2z"
  })));
};
export default SvgAirportShuttle;